import { Button, Popover, Spinner} from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import autobind from "autobind-decorator";
import Padding from "common/fragments/Padding";
import { Query } from "core/api/typedQuery";
import Label from "core/components/label/Label";
import { IPanelProps, Panel } from "core/decorators/Panel";
import React, { SyntheticEvent } from "react";
import ForumSubscriptionForm from "./component/subscriptions/ForumSubscriptionForm";
import { ForumSubscription } from "./entity/ForumSubscription";
import ForumSubscriptionConfig from "./config/ForumSubscriptionConfig"
import forumDeletionEvent from "./ForumDeletionEvent";

//query just for deciding the label (follow or followed)
const SubQuery = Query.queryMany<ForumSubscription, {forumId: number}>(ForumSubscription);
@Panel({ id: "forumSubscription", configClass: ForumSubscriptionConfig})
class ForumSubsciptionPanel extends React.Component<IPanelProps<ForumSubscriptionConfig>,{visible:boolean}> {
    public refetch:()=> void;
    constructor(props){
        super(props);
        this.state = {visible:false};
        this.refetch=()=>{};
    }
    public componentDidMount(){
        forumDeletionEvent.add(this);

        if (!this.props.forumId) {
            this.props.actions.saveForumId({ forumId: this.props.config.forumId });
        }

    }
    public componentWillUnmount(){
        forumDeletionEvent.remove(this);
    }
    public render(){
        let content = (forumId:number,refetch:() => void)=>(
            <Padding.Base>
                <div className="subscriptions-popover-form">
                    <ForumSubscriptionForm forumId={forumId} onAfterSave={(r) => {
                        this.setState({visible:false});
                        refetch();
                    }} />
                </div>
            </Padding.Base>
        );
        return (
                <SubQuery params={{forumId: Number(this.props.config.forumId)}}>
                    { 
                        ({data,loading,refetch}) => {
                            if(loading)
                                return <Spinner />;
                            this.refetch = ()=>refetch();
                            return (
                                <Popover
                                    onInteraction={this.handleInteraction}
                                    isOpen={this.state.visible}
                                    content={content(Number(this.props.config.forumId),refetch)}
                                > 
                                    <Button icon={IconNames.CARET_DOWN} onClick={() => this.setState({visible:true})}>
                                    {
                                        this.isFollwed(data && data.length && data[0])?
                                            (<Label k="forum.followed" v="Followed Forum" />
                                            ) : (<Label k="forum.follow" v="Follow Entire Forum" />)
                                    }     
                                    </Button>        
                                </Popover>
                            );               
                        }   
                    }
                </SubQuery>
        );
    }
    
    @autobind
	private handleInteraction(nextOpenState: boolean, e:SyntheticEvent<HTMLElement>) {
		if(!nextOpenState || (e !== undefined && e.type !== "click")) {
            this.setState({visible:false});
        }
    }

    @autobind
    private isFollwed(fs:ForumSubscription){
        return fs && ((fs.instant && fs.emailNotification) || (fs.emailNotification && (fs.digest == "daily" || fs.digest == "weekly")));
    }
    
}


// WEBPACK FOOTER //
// ./src/panels/forum/ForumSubscriptions.panel.tsx